import React from 'react'
import { Tag } from 'antd'
import styled from 'styled-components'

const StyledDiv = styled.div`
  margin-top: 12px;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  row-gap: 14px;
  column-gap: 4px;

  .ant-tag-checkable {
    padding: 16px 20.5px;
    font-size: 16px;
    font-weight: 500;
  }

  .ant-tag-checkable:not(.ant-tag-checkable-checked) {
    background-color: rgb(235, 236, 238);
  }

  .ant-tag-checkable-checked {
    background-color: #264382;
  }
`

export default function TagSelect(props) {
  const { options, onChange } = props
  const value = props.value || []

  const handleChange = (tag, checked) => {
    const nextSelectedTags = checked
      ? [...value, tag]
      : value.filter((t) => t !== tag)
    onChange(nextSelectedTags)
  }

  return (
    <StyledDiv>
      {options.map((tag) => (
        <Tag.CheckableTag
          key={tag}
          checked={value.includes(tag)}
          onChange={(checked) => handleChange(tag, checked)}
        >
          {tag}
        </Tag.CheckableTag>
      ))}
    </StyledDiv>
  )
}
